export default "__VITE_ASSET__5f4032b4__"